import { FC, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { LoginWrapper } from './login-wrapper';
import { PasswordLoginForm } from './supabase/password-login-form';
import { loginSchema } from './login-schema';
import { OtpLoginForm } from './supabase/otp-login-form';

type LoginDialogProps = {
    open: boolean;
    closeFn: () => void;
    currentEmail?: string;
};

export const LoginDialog: FC<LoginDialogProps> = ({ open, closeFn, currentEmail }) => {
    const [usePasswordLogin, setUsePasswordLogin] = useState(false);

    const toggleLoginMode = () => setUsePasswordLogin((prev) => !prev);
    const methods = useForm({
        resolver: yupResolver(loginSchema),
        defaultValues: { email: currentEmail ?? '', password: '', token: '' },
    });

    const onClose = () => {
        closeFn();
        methods.reset();
        setUsePasswordLogin(false);
    };

    useEffect(() => {
        if (open) {
            methods.reset({ email: currentEmail ?? '' });
        }
    }, [open]);

    if (!open) return null;

    return (
        <FormProvider {...methods}>
            <LoginWrapper open onClose={onClose} key="loginWrapper">
                {usePasswordLogin ? (
                    <PasswordLoginForm toggleLoginMode={toggleLoginMode} onClose={onClose} />
                ) : (
                    <OtpLoginForm toggleLoginMode={toggleLoginMode} onClose={onClose} />
                )}
            </LoginWrapper>
        </FormProvider>
    );
};
